export default "__VITE_ASSET__BqCJ8_Sh__"